import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { trackEvent } from '@xingternal/hops-tracking';
import { useViewerData } from '@xingternal/hub';

import { routes } from '@/config';
import { useApplicationCvFileId, useJobGlobalIdValue, useJobIdValue } from '@/domain/job-application/contexts';
import { useUpdateProfileCvMutation } from '@/graphql/generated';

import { FLOW_IDENTIFIER_LOGGED_IN } from '../../constants';

import * as S from './update-profile-cv-cta.styles';

export const UpdateProfileCvCta: React.VFC = () => {
  const jobId = useJobIdValue();
  const source = useJobGlobalIdValue();
  const uploadId = useApplicationCvFileId();
  const flowIdentifier = FLOW_IDENTIFIER_LOGGED_IN;
  const { data: userData } = useViewerData();
  const userId = userData?.user?.id;
  const [showErrorBanner, setShowErrorBanner] = useState(false);
  const openProfileUpdateTab = useCallback((): void => {
    window.open(`${routes.updateProfileWithCv}?sc_o=jobs_apply_complete_update_profile`, '_blank');
  }, []);
  const onUpdateProfileCVError = useCallback((): void => {
    setShowErrorBanner(true);
  }, []);
  const [updateProfileCvMutation, { data, loading, error, called }] = useUpdateProfileCvMutation({
    variables: { input: { userId, uploadId, source, flowIdentifier } },
    onCompleted: (mutationData) => {
      if (mutationData?.createCvUploadParsedCvByUserId?.__typename === 'CvUploadError') {
        onUpdateProfileCVError();
      } else {
        openProfileUpdateTab();
      }
    },
    onError: onUpdateProfileCVError,
  });
  const onCtaClick = (): void => {
    if (!called || error || data?.createCvUploadParsedCvByUserId?.__typename === 'CvUploadError') {
      setShowErrorBanner(false);
      updateProfileCvMutation();
    } else {
      openProfileUpdateTab();
    }
  };

  useEffect(() => {
    showErrorBanner &&
      trackEvent('PropTrackAction', {
        PropFormList: 'jobs_apply_form_error',
        PropTrackActionList: 'jobs_apply_complete_parse_cv_error',
        PropJobsId: jobId,
      });
  }, [showErrorBanner, jobId]);

  return (
    <>
      <S.UpdateProfileCta variant="primary" size="medium" onClick={onCtaClick} loading={loading}>
        <FormattedMessage id="JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_CTA" />
      </S.UpdateProfileCta>
      <S.BannerWrapper>
        <S.Banner
          display="inline"
          handleOnClose={() => setShowErrorBanner(false)}
          show={showErrorBanner}
          variant="error"
        >
          <FormattedMessage id="JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_CTA_ERROR" />
        </S.Banner>
      </S.BannerWrapper>
    </>
  );
};
